import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const inputLength = '80%';

export const metadataFieldFormStyles = makeStyles((theme: Theme) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    padding: '20px 20px 20px 20px',
    justifyContent: 'space-between',
  },
  fieldErrors: {
    color: theme.palette.error.main,
  },
  textInput: {
    width: inputLength,
    height: '30px',
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '5px',
    padding: '.5em',
  },
  formItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '10px 0px 10px 0px',
  },
  labelColumn: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '20%',
    minWidth: 140,
  },
  valueColumn: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: inputLength,
  },
  formItemChoices: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px 0px 10px 0px',
    minHeight: '120px',
    maxHeight: '200px',
    overflow: 'auto',
  },
  addButton: {
    margin: '10px 0 10px 0',
  },
  formInput: {
    width: inputLength,
  },

  formCheckboxWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: inputLength,
  },
  formCheckboxLabel: {
    width: inputLength,
  },

  choicesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '80%',
  },
  choice: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

export const adminFormModalStyles = makeStyles((theme: Theme) => ({
  headerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  buttonWrapper: {
    padding: '20px 20px 20px 20px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto 20px auto',
    padding: '10px 0',
    fontSize: '20px',
    backgroundColor: theme.palette.primary.main,
  },
}));
